<template>
  <div class="c-proList c-standard fullWidth">
    <h3 class='title_h3 relative'>
      <span>{{ text.title }}</span>
      <div class="textBgCenter absolute" style='top: -50%'></div>
    </h3>
    <p>{{ text.content }}</p>
    <div class="c-proList__block">
      <div class="c-proList__item" v-for="(item, index) in list" :key="index" @click="routeTo(index)" :style="{backgroundImage:'url('+ item.img +')'}">
        <p>{{ item.title }}</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'productList',
    data(){
      return{
        text:{
          title: this.$t('product.list.title'),
          content: this.$t('product.list.content')
        },
        list: [
          { img: require('../../assets/img/product/product_banner_01.jpg'), title: this.$t('product_1.banner.title') },
          { img: require('../../assets/img/product/product_banner_02.jpg'), title: this.$t('product_2.banner.title') },
          { img: require('../../assets/img/product/product_banner_03.jpg'), title: this.$t('product_3.banner.title') },
          { img: require('../../assets/img/product/product_banner_04.jpg'), title: this.$t('product_4.banner.title') },
          { img: require('../../assets/img/product/product_banner_05.jpg'), title: this.$t('product_5.banner.title') },
          { img: require('../../assets/img/product/product_banner_06.jpg'), title: this.$t('product_6.banner.title') },
        ]
      }
    },
    computed: {
    },
    methods:{
      routeTo(index){
        let page = index + 1
        let link = "product_" + page
        if (page != 1) {
          this.$router.push({
            name: link
          })
        }
      },
    },
    created(){

    }
  }
</script>

<style>


</style>
